export default "__VITE_ASSET___xfOZiIQ__"